function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    style: {
      maxWidth: "100%"
    },
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    style: {},
    fill: "#fff",
    id: titleId
  }, "Artboard 11") : title ? /*#__PURE__*/React.createElement("title", {
    style: {},
    fill: "#fff",
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M34.39,31.72l-4.66-.24a15.77,15.77,0,0,0-11.94,4.6L10,43.82A3.8,3.8,0,0,0,11.28,50L22,54.47a70.44,70.44,0,0,0-2,7.4,3,3,0,0,0,.81,2.76l14.6,14.6a3,3,0,0,0,2.76.81,70,70,0,0,0,7.4-2L50,88.72A3.8,3.8,0,0,0,56.18,90l7.74-7.74a15.78,15.78,0,0,0,4.59-11.94l-.24-4.66C85.2,52.12,95.38,32.19,98.52,6.33a4.36,4.36,0,0,0-4.85-4.85C67.81,4.63,47.88,14.8,34.39,31.72Zm57.91-24c-3.31,23.79-13,42-28.91,54.11a3,3,0,0,0-1.18,2.54l.32,6.21A9.77,9.77,0,0,1,59.67,78l-5.41,5.41L50,73.06a3,3,0,0,0-3.84-1.65,66.13,66.13,0,0,1-7.71,2.41L26.18,61.56a66.31,66.31,0,0,1,2.41-7.71A3,3,0,0,0,26.94,50L16.62,45.74,22,40.33a9.79,9.79,0,0,1,7.4-2.85l6.21.32a3,3,0,0,0,2.54-1.18C50.3,20.74,68.5,11,92.29,7.71Zm-24.12,35a10.92,10.92,0,1,0-7.72-3.19A10.89,10.89,0,0,0,68.17,42.75Zm-3.48-14.4a4.92,4.92,0,1,1,0,7A4.91,4.91,0,0,1,64.69,28.35ZM5.19,98.56h.06c16.43-.29,24.5-9,27.21-12.78a3.49,3.49,0,0,0-3.68-5.42,16.46,16.46,0,0,1-6.06.41,4,4,0,0,1-3.49-3.49,16.45,16.45,0,0,1,.41-6.06,3.49,3.49,0,0,0-5.42-3.68C10.48,70.24,1.73,78.32,1.45,94.74a3.76,3.76,0,0,0,3.75,3.82Zm8-21.66q0,.55.1,1.09A10,10,0,0,0,22,86.72l1.09.1A28.77,28.77,0,0,1,7.56,92.44,28.77,28.77,0,0,1,13.17,76.9Z",
    style: {},
    fill: "#fff"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvvg1);
export default __webpack_public_path__ + "static/media/svvg1.7bdde83016eb47c3433b8e5a02c46851.svg";
export { ForwardRef as ReactComponent };